<template>
  <div id="TakeAttendance">
    <div id="scrollBody" class="TakeAttendance">
      <div class="tab-btns">
        <div v-bind:class="{ cur: index === 1 }" @click="tabChange(1)">考勤汇总</div>
        <div v-bind:class="{ cur: index === 2 }" @click="tabChange(2)">考勤详情</div>
        <span></span>
      </div>
      <div class="attdence-head" v-if="index === 1">
        <div class="attdence-detail-tit ts">
          <span v-cloak>{{ xy.getChinesesWeekForNumSmall(classNode.Day) }}</span>
          <span v-cloak style="margin: 0 0.5em"
            >{{ xy.getAMorPMCHN(classNode.AMorPM)
            }}<span v-if="classNode.AMorPM === 'AM' || classNode.AMorPM === 'PM'">第</span
            >{{ xy.convertRangeNumber(classNode.AMorPMOrder)
            }}<span v-if="classNode.AMorPM === 'AM' || classNode.AMorPM === 'PM'">节</span></span
          >
          <span v-cloak>{{ classNode.SubjectName }}</span>
        </div>
        <div v-cloak class="attdence-detail-date">
          <span>{{ xy.moment(classNode.ClassDate).format('YYYY-MM-DD') }}</span>
        </div>
        <div class="list-bottom">
          <ul class="list clearfix">
            <li v-cloak class="list-item nowrap" v-if="row.length !== 0">
              <span>{{ row[1].AttTypeNum }}</span>
              <br />{{ row[1].AttTypeName }}
            </li>
            <li v-cloak class="list-item nowrap" v-for="(item, index) in arrRow" v-bind:key="index">
              <span>{{ item.AttTypeNum }}</span>
              <br />{{ item.AttTypeName }}人次
            </li>
          </ul>
        </div>
      </div>
      <div class="student-con" v-if="index === 2">
        <div class="student-search clearfix">
          <van-search
            class="searchs fl"
            placeholder="输入学生姓名快速查找学生"
            v-on:input="inputFunc"
            v-model="searchVal"
            @search="nameSearch"
          />
          <div class="total-change fr" @click="batchOperation"><span></span>批量操作</div>
        </div>
        <div class="student-list clearfix" v-for="(item, index) in datatable" :key="index">
          <div class="list-num fl" v-cloak><span v-if="index < 9">0</span>{{ index + 1 }}</div>
          <div class="list-studentInfo">
            <h4 class="nowrap" v-cloak>{{ item.FullName }}</h4>
            <span class="nowrap" v-cloak
              >考勤结果：{{ item.TypeName === null ? '请选择' : item.TypeName }}</span
            >
            <p class="nowrap" v-cloak>用&nbsp;&nbsp;户&nbsp;&nbsp;名：{{ item.UserName }}</p>
          </div>

          <div class="list-editType" @click="setStudentAttType(item)">
            <i></i>
          </div>
        </div>
      </div>
      <!-- <div class="bottom-btn"></div> -->
    </div>
    <van-popup v-model="display_popWindow" position="bottom">
      <ModifyStatus
        v-if="display_student_typeList"
        nameKey="AttTypeName"
        :typeList="attTypeList"
        :current-selected="false"
        @cancel="hide_student_typeList"
        @confirm="confirm_student_typeList"
        @closed="display_student_typeList = false"
      ></ModifyStatus>
    </van-popup>
    <AttTypeBatchModify
      v-if="batchModel"
      class="components-attTypeBatchModify-wrapper"
      :classID="classNode.ClassTableGenerateBaseID"
      :studentListIncoming="studentList_all"
      :typeList="attTypeList"
      @exit="exit_batchModel"
    ></AttTypeBatchModify>
  </div>
</template>

<script>
import ModifyStatus from '@/pages/attendance/components/ModifyStatus.vue'
import AttTypeBatchModify from '@/pages/attendance/components/AttTypeBatchModify.vue'
export default {
  name: 'TakeAttendance',
  components: {
    ModifyStatus,
    AttTypeBatchModify
  },
  data() {
    return {
      classNode: '',
      AMorPMOrderName: '',
      dateType: [], //考勤类型列表
      datatable: [], //学生列表(随数据更新而更新)
      studentList_all: [], // 学生列表（完整列表，仅在首次加载页面时获取，固定不变）
      normArr: [], //正常考勤学生
      normal: '', //正常考勤学生人数

      searchVal: '', //输入框搜索

      attTypeList: [], //所有考勤状态
      row: [],
      arrRow:[],

      index: 1, //tab切换展示,
      current_student: undefined, // 当前学生

      // 请假类型（暂定）
      display_popWindow: false,
      display_student_typeList: false, // 请假类型弹出层
      leaveTypes: [], // 请假类型

      // 批量模式
      batchModel: false
    }
  },
  computed: {
    attTypeList_unusual: function() {
      return this.attTypeList.filter((item, index) => {
        return index > 0
      })
    },
    leaveTypes_list: function() {
      const list = this.leaveTypes.map(item => {
        return item.StudentAttendanceTypeName
      })
      return list
    }
  },
  methods: {
    tabChange: function(index) {
      if (index === 1) {
        this.index = 1
      } else {
        this.index = 2
      }
    },
    //所有考勤状态-用于顶部数据统计和修改考勤时
    async getColumns() {
      var _this = this
      const res = await this.xyapi.get(
        this.$store.state.apiPath + '/api/AttsLesson/GetTypeForColumn'
      )
      if (res.success) {
        _this.attTypeList = res.data
      } else {
        this.xy.msgError(res.msg)
      }
    },
    //顶部统计数据展示
    async getHeadInfo() {
      const params = {
        baseID: this.classNode.ClassTableGenerateBaseID
      }
      const res = await this.xyapi.get(
        // this.$store.state.apiPath + '/api/ClassAttStatistics/GetForDayStatistics',
        this.$store.state.apiPath + '/api/ClassAttStatistics/GetForCTT',
        params
      )
      if (res.success) {
        // this.$set(this, 'row', res.data[0])
        this.arrRow = res.data.Summary
        console.log(this.arrRow)
        this.row = res.data.Summary.splice(0, 2)
        
      } else {
        this.xy.msgError(res.msg)
      }
    },
    //获取课程下学生集合
    async modalEditAttend(setAllList) {
      var _this = this
      const params = {
        baseID: _this.classNode.ClassTableGenerateBaseID,
        username: _this.searchVal
      }
      const res = await this.xyapi.get(
        this.$store.state.apiPath + '/api/AttsLesson/GetStudent',
        params
      )
      if (res.success) {
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].list = []
          //头像获取
          res.data[i].Icon !== null && res.data[i].Icon.length > 0
            ? (res.data[i].Icon = this.xyMApi+'/base'+ res.data[i].Icon)
            : (res.data[i].Icon = '') // 原：/image/yrykb.png
        }
        _this.datatable = res.data
        if (setAllList) {
          // 设置为完整列表
          this.$set(this, 'studentList_all', res.data)
        }
        _this.normArr.length = 0 //重置
        for (var y = 0; y < _this.datatable.length; y++) {
          if (_this.datatable[y].TypeID === 1 && _this.datatable[y].AttFrom !== 2) {
            _this.normArr.push(_this.datatable[y].TypeID)
          }
        }
        _this.normal = _this.normArr.length

        _this.getType()
      } else {
        this.xy.msgError(res.msg)
      }
    },
    //获取考勤类型
    async getType() {
      const res = await this.xyapi.get(this.$store.state.apiPath + '/api/AttsSetting/GetType')
      if (res.success) {
        this.leaveTypes = res.data
      } else {
        this.xy.msgError(res.msg)
      }
    },

    //搜索内容为空时展示全部
    inputFunc: function() {
      if (this.searchVal.trim() === '') {
        this.searchVal = ''
        this.modalEditAttend()
      }
    },
    //搜索
    nameSearch: function(value) {
      this.searchVal = value
      this.modalEditAttend()
    },
    // 单独对此学生设置考勤类型
    setStudentAttType(item) {
      this.display_student_typeList = true
      this.display_popWindow = true
      this.current_student = item
    },
    // 批量操作
    batchOperation() {
      this.batchModel = true
    },
    hide_student_typeList() {
      this.display_popWindow = false
    },
    confirm_student_typeList(value) {
      this.editAttendType(value)
      this.hide_student_typeList()
    },
    // 改变单个学生的考勤状态
    async editAttendType(item) {
      let students = []
      students.push(this.current_student.StudentID)
      const params = {
        baseID: this.classNode.ClassTableGenerateBaseID,
        typeID: item.AttTypeID,
        studentIDs: students
      }
      const res = await this.xyapi.post(
        this.$store.state.apiPath + '/api/AttsLesson/SetStudentAttendanceState',
        params
      )
      if (res.success) {
        this.xy.msgSuc('修改成功！')
        this.getHeadInfo() //刷新正常考勤人数
        this.modalEditAttend(true)
      } else {
        this.xy.msgError(res.msg)
      }
    },
    exit_batchModel(refresh) {
      if (refresh) {
        this.getHeadInfo() //刷新正常考勤人数
        this.modalEditAttend(true)
      }
      this.batchModel = false
      scrollTo(0, 0)
    }
  },
  watch: {
    searchVal: function() {}
  },
  created: function() {
    this.classNode = this.$route.params.classNode
    this.getColumns()
    this.getHeadInfo()
  },
  mounted: function() {
    this.modalEditAttend(true)
  }
}
</script>

<style lang="less" scoped>
.nowrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/*列表通用样式*/
#scrollBody {
  margin-bottom: 110px;
  & .scrollList li {
    background: #fff;
    margin-bottom: 6px;
  }

  & .box-body {
    border-bottom: 1px solid #eee;
    padding: 12px 10px;
  }

  & .box-body .list-left {
    float: left;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    /* border-radius: 50%; */
    background: rgb(72, 153, 251);
  }

  & .box-body .list-right {
    margin-left: 60px;
  }

  & .box-body h3 {
    margin-bottom: 12px;
    font-size: 16px;
    /*font-weight:700;*/
    color: #333;
  }

  & .box-body h4 {
    font-size: 14px;
    margin-bottom: 6px;
  }

  & .box-footer {
    clear: both;
    padding: 10px;
  }

  & .box-footer span {
    margin-left: 8px;
    padding: 10px 0;
  }

  & .box-footer i {
    font-size: 16px !important;
    margin-right: 4px;
  }

  & .box-footer .compose {
    color: #f90;
  }

  & .box-footer .delete {
    color: #f05a4a;
  }

  & .creatBtn {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 99;
    color: #fff;
  }
}

/*tab切换 两项切换*/
.tab {
  &-btns {
    display: flex;
    font-size: 28px;
    height: 90px;
    line-height: 90px;
    background: #fff;
    color: #acacac;
    position: relative;
  }

  &-btns span {
    position: absolute;
    width: 2px;
    height: 44px;
    background: #e1e1e1;
    left: 50%;
    top: 23px;
  }

  &-btns div {
    flex: 1;
    text-align: center;
  }

  &-btns div.cur {
    color: #2b303b;
    font-weight: bold;
  }
}

/*tab切换 end*/
.list {
  // &-bottom {
  //   overflow: hidden;
  // }
  &-bottom {
    width: 100%;
    padding-top: 8px;
    // overflow-x: scroll;
  }
  &-bottom .view-more {
    height: 82px;
    line-height: 82px;
    text-align: center;
    color: #4a98fd;
    font-size: 26px;
    /*border-top:1px solid #f0f0f1;*/
    position: relative;
  }
  &-bottom .view-more:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-top: 1px solid #f0f0f1;
    width: 200%;
    height: 200%;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: left top;
    transform-origin: left top;
  }
  // &-bottom .list {
  //   overflow: hidden;
  // }
  &-bottom .list.up {
    height: 145px;
  }
  &-bottom .list.down {
    height: auto;
  }
  &-bottom .list .list-item {
    font-size: 26px;
    color: #999;
    text-align: center;
    width: 33.333%;
    height: 133px;
    float: left;
  }
  &-bottom .list .list-item.list {
    width: 16.666%;
    height: 150px;
  }
  &-bottom .list .list-item span {
    color: #333;
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 3px;
    display: inline-block;
  }
  &-bottom .list .list-item:nth-child(1) span,
  &-bottom .list .list-item:nth-child(1) i {
    color: #6d8dfa;
    font-weight: bold;
  }
  &-bottom .list .list-item:nth-child(2) span {
    color: #f0ab34;
  }
}

.TakeAttendance {
  font-size: 24px;
}

.attdence {
  &-head {
    background: #fff;
  }
  &-detail-tit {
    font-size: 30px;
    color: #333;
    margin: 0 0 45px 0;
    padding-top: 26px;
    text-align: center;
    font-weight: bold;
  }
  &-detail-tit.ts {
    margin: 0 0 12px 0;
  }
  &-detail-date {
    margin-bottom: 30px;
    text-align: center;
  }
  &-detail-date span {
    display: inline-block;
    min-width: 198px;
    padding: 0 20px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 22px;
    color: #8a8a8a;
    background: #efefef;
    border-radius: 16px 0;
    margin: 0 auto;
  }
}

.student {
  &-list {
    padding: 22px 5% 11px;
    background: #fff;
    position: relative;
  }
  &-list:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-bottom: 1px solid #eaf2ff;
    width: 200%;
    height: 200%;
    box-sizing: border-box;
    transform: scale(0.5);
    transform-origin: left top;
  }
  &-list .list-num {
    width: 60px;
    font-size: 38px;
    color: #4a98fd;
  }
  &-list .list-studentInfo {
    padding-left: 60px;
    font-size: 26px;
  }
  &-list .list-studentInfo h4 {
    font-size: 30px;
    color: #333;
    font-weight: bold;
    max-width: 85%;
  }
  &-list .list-studentInfo h4 span {
    font-size: 30px;
    color: #666;
    font-weight: normal;
  }
  &-list .list-studentInfo > span {
    font-size: 26px;
    color: #5c5c5c;
    margin: 20px 0 8px;
    display: block;
    max-width: 85%;
  }
  &-list .list-studentInfo > span.add-span {
    margin: 0 0 5px;
  }
  .alignJ {
    display: inline-block;
    min-width: 105px;
    text-align-last: justify;
    text-align: justify;
  }
  &-list .list-studentInfo > p {
    font-size: 24px;
    color: #999;
    max-width: 85%;
    margin-bottom: 2px;
  }
  &-list .list-editType {
    position: absolute;
    top: 32px;
    right: 42px;
    padding: 20px;
    font-size: 28px;
    color: #666;
  }
  &-list .list-editType i {
    width: 32px;
    height: 32px;
    direction: rtl;
    border: none;
    color: #666;
    background: url(~@/assets/attendance/pen-inbox-line-black.png) no-repeat right center;
    background-size: contain;
    padding-right: 40px;
  }
  &-list .list-editType select option {
    direction: ltr;
  }
  &-con .student-search {
    padding: 7px 5% 13px;
    background: #fff;
    margin-bottom: 14px;
  }
  &-con .student-search .searchs {
    width: 70%;
    padding: 0;
    border-radius: 40px;
    overflow: hidden; // 此处仅为体现圆角。若有冲突，可考虑去掉该调整
  }
  &-search .total-change {
    width: 190px;
    height: 62px;
    line-height: 62px;
    background: #4a98fd;
    background-size: contain;
    padding-left: 20px;
    border-radius: 30px;
    font-size: 28px;
    color: #fff;
    text-indent: 10px;
    box-shadow: 0 2px 6px 0 rgba(74, 152, 253, 1);
  }
  &-search .total-change span {
    float: left;
    width: 30px;
    height: 62px;
    background: url(~@/assets/attendance/add-batch-white.png) no-repeat center;
    background-size: contain;
  }
}

.components-attTypeBatchModify-wrapper {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  overflow: hidden;
}
</style>
